import { render, staticRenderFns } from "./DirectToModal.vue?vue&type=template&id=99350794&scoped=true"
import script from "./DirectToModal.vue?vue&type=script&lang=js"
export * from "./DirectToModal.vue?vue&type=script&lang=js"
import style0 from "./DirectToModal.vue?vue&type=style&index=0&id=99350794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99350794",
  null
  
)

export default component.exports